import {Box, Chip, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";
import SimpleBar from "simplebar-react";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";
const filters = ConfigurationHelper.getCategories();
const activeStyle = {
    backgroundColor: '#000000',
    color: '#fff',
    "&:hover": {
        backgroundColor: '#000000 !important',
    },
    '& p': {
        color: '#fff',
    },
    "& .MuiSvgIcon-root": {
        color: "#ffffff"
    }
}
const CategoriesList = ({onClickCategory, selectedFilters}) =>{
    const [initialized, setInitialized] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [filtersWithData, setFiltersWithData] = useState([]);
    useEffect(() => {
        const loginId = TVSite.loginId;
        const requestAPI = (category) =>{

            const requestQuery = `
                    {
                      content(client_id: ${loginId}, filter:{
                      AND: [
                        {attribute:{code: "show_on_grid", value: "yes"}}
                        {attribute:{code: "category", value: "${category}"}}
                      ]
                      
                      }) {
                        total
                      }
                    }
                    `;
            const phpEnvName = window?.TVSite?.phpEnvName;
            const env = phpEnvName === "local" ? "test" : phpEnvName;
            const apiUrl = `https://${env}.creatable.io/v3/api/search/graphql`;

            return axios.post(apiUrl, {query: requestQuery});
        }
        if(!initialized){
            setInitialized(true);
            Promise.all(filters.map(filter=> new Promise((resolve, reject)=>{
                requestAPI(filter.value).then(response=>{
                    resolve({category: filter.value, total:response.data.data.content.total})
                })
            }))).then(response=>{
                const withData = response.filter(f=>f.total > 0).map(m=>m.category);
                setFiltersWithData(filters.filter(f=>withData.includes(f.value)));
                setLoaded(true);
            });
        }

        //const items =  response.data.data.content.total
    }, [filters, initialized]);
    const isAllSelected = selectedFilters.includes('All');

    return <Box pb={2}>
        {(filtersWithData.length > 0) && <SimpleBar style={{maxHeight: "53px", overflowY: "hidden"}}>

            <Box display="flex" width={"100%"}>
                <Box>
                    <Chip data-testId={"hub-filter-category-all"} onClick={() => onClickCategory("All")} sx={isAllSelected ? activeStyle : null}
                          variant={'outlined'} icon={isAllSelected ? <DoneIcon/> : null}
                          label={<Typography>All</Typography>}/>
                </Box>
                {
                    filtersWithData.map((category, index) => {
                        const isActive = selectedFilters.includes(category.value);
                        return <Box key={index} ml={1}>
                            <Chip data-testId={"hub-filter-category"} icon={isActive ? <DoneIcon/> : null} sx={isActive ? activeStyle : null}
                                  onClick={() => onClickCategory(category.value)} variant={'outlined'}
                                  label={<Typography>{category.label}</Typography>}/>
                        </Box>
                    })
                }
            </Box>
        </SimpleBar>}
    </Box>
}
export default CategoriesList;